module.exports = __webpack_public_path__ + "static/media/office-tel-aviv@2x.1b82ffac.png";